import setPostMeasureOptionsCookie from '../setPostMeasureOptionsCookie';
import getPCPUrl from '../getPCPUrl';

export default itemId => (dispatch) => {
  dispatch(setPostMeasureOptionsCookie(itemId));
  window.location.href = dispatch(getPCPUrl(itemId));
};
